import AddamountForm from './amountForm'


function App() {

  return (
      <AddamountForm />   
  );
}

export default App;
